import React from "react";
import { useSelector } from "react-redux";
import LoaderGif from "../../assets/loader.gif";

export default function Loader() {
  const isLoading = useSelector((state) => state?.loading?.isLoading);
  if (isLoading) {
    return (
      <div className="loading">
        <span>
          <img src={LoaderGif} alt="" />
        </span>
      </div>
    );
  } else {
    return "";
  }
}
